import { Delete } from '@mui/icons-material';
import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
} from 'reactstrap';

const EditSubjectModal = ({
  isOpen,
  toggleModal,
  editSubject,
  subjectDataToEdit,
}) => {
  const [subjectData, setSubjectData] = useState({
    name: '',
    languages: [''],
    primaryLanguage: '',
    topics: [''],
    totalQuestions: 0,
    status: 0,
    type: 'Subject',
  });

  useEffect(() => {
    if (subjectDataToEdit) {
      console.log(subjectDataToEdit, 'subjectDataToEdit');
      setSubjectData(subjectDataToEdit);
    }
  }, [subjectDataToEdit]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSubjectData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleArrayChange = (e, field) => {
    const {
      value,
      dataset: { index },
    } = e.target;
    setSubjectData((prevState) => {
      const updatedArray = [...prevState[field]];
      updatedArray[index] = value;
      return { ...prevState, [field]: updatedArray };
    });
  };

  const addNewField = (field) => {
    setSubjectData((prevState) => ({
      ...prevState,
      [field]: [...prevState[field], ''],
    }));
  };

  const removeField = (field, index) => {
    setSubjectData((prevState) => ({
      ...prevState,
      [field]: prevState[field].filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, languages, primaryLanguages, topics, totalQuestions } =
      subjectData;
    console.log(subjectData, 'subjectData');

    if (
      !name.trim() ||
      languages.some((lang) => !lang.trim()) ||
      !primaryLanguages.trim() ||
      topics.some((topic) => !topic.trim()) ||
      totalQuestions < 0
    ) {
      alert(
        'All fields are required, and total questions must be a non-negative number.'
      );
      return;
    }

    const updatedSubjectRecord = {
      ...subjectData,
      updatedAt: new Date().toISOString(),
    };
    console.log(updatedSubjectRecord, 'updatedSubjectRecord');
    editSubject(updatedSubjectRecord);
    toggleModal();
  };

  const modalHeaderStyle = {
    backgroundColor: 'rgb(39, 41, 61)',
    padding: '10px 15px',
    color: '#fff',
    fontSize: '18px',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  };

  const modalBodyStyle = {
    backgroundColor: 'rgb(39, 41, 61)',
    paddingTop: '20px',
    overflowY: 'auto',
    height: '71.5vh',
  };

  const inputStyle = {
    backgroundColor: '#2c2f47',
    color: '#fff',
    border: '1px solid #5a5e75',
  };

  console.log('sk', subjectData);

  return (
    <Modal isOpen={isOpen} toggle={toggleModal} size='lg' style={{ transform: 'translateY(0)' }}>
      <div style={modalHeaderStyle}>
        Edit Subject
        <button
          type='button'
          className='close'
          onClick={toggleModal}
          style={{
            color: '#fff',
            fontSize: '24px',
            border: 'none',
            background: 'none',
            cursor: 'pointer',
          }}
        >
          &times;
        </button>
      </div>

      <ModalBody style={modalBodyStyle}>
        <form onSubmit={handleSubmit}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '20px',
            }}
          >
            {/* Name Field */}
            <FormGroup>
              <label style={{ color: '#fff' }}>Subject Name*</label>
              <Input
                type='text'
                name='name'
                value={subjectData.name}
                onChange={handleInputChange}
                disabled
                placeholder='Enter subject name'
                required
                style={inputStyle}
              />
            </FormGroup>

            {/* Topics Field */}
            <FormGroup>
              <label style={{ color: '#fff' }}>Topics*</label>
              {subjectData.topics.map((topic, index) => (
                <div
                  key={index}
                  style={{ display: 'flex', marginBottom: '10px' }}
                >
                  <Input
                    type='text'
                    value={topic}
                    data-index={index}
                    className={subjectData.primaryLanguages == 'fganh' || subjectData.primaryLanguages == 'हिंदी' ? 'hinditext':''}
                    onChange={(e) => handleArrayChange(e, 'topics')}
                    placeholder={`Enter topic ${index + 1}`}
                    style={inputStyle}
                  />
                  <Delete
                    aria-label={`Delete topic ${index + 1}`}
                    style={{
                      color: 'red',
                      cursor: 'pointer',
                      marginLeft: '10px',
                    }}
                    onClick={() => removeField('topics', index)}
                  />
                </div>
              ))}
              <Button
                color='info'
                onClick={() => addNewField('topics')}
                style={{ marginBottom: '10px' }}
              >
                Add Topic
              </Button>
            </FormGroup>

            {/* Languages Field */}
            <FormGroup>
              <label style={{ color: '#fff' }}>Languages*</label>
              {subjectData.languages.map((language, index) => (
                <div
                  key={index}
                  style={{ display: 'flex', marginBottom: '10px' }}
                >
                  <Input
                    type='text'
                    value={language}
                    data-index={index}
                    onChange={(e) => handleArrayChange(e, 'languages')}
                    placeholder={`Enter language ${index + 1}`}
                    style={inputStyle}
                    disabled={language === subjectData.primaryLanguages}
                  />
                  <Delete
                    aria-label={`Delete language ${index + 1}`}
                    style={{
                      color: 'red',
                      cursor: 'pointer',
                      marginTop:"7px",
                      marginLeft: '10px',
                      visibility: (language == subjectData.primaryLanguages) ? 'hidden':''
                    }}
                    onClick={() => removeField('languages', index)}
                  />
                </div>
              ))}
              <Button
                color='info'
                onClick={() => addNewField('languages')}
                style={{ marginBottom: '10px' }}
              >
                Add Language
              </Button>
            </FormGroup>

            {/* Primary Language Display */}
            {subjectData.languages.some((lang) => lang.trim()) && (
              <FormGroup>
                <label style={{ color: '#fff' }}>Primary Language*</label>
                <div
                  style={{
                    backgroundColor: 'rgb(44, 47, 71)',
                    color: 'rgb(255, 255, 255)',
                    border: '1px solid rgb(90, 94, 117)',
                    height: '37px',
                    width: '365px',
                    borderRadius: '5px',
                    padding: '8px 10px',
                    display: 'flex',
                    alignItems: 'center',
                    cursor:'no-drop'
                  }}
                >
                  {subjectData.primaryLanguages || 'Not Set'}
                </div>
              </FormGroup>
            )}
          </div>
        </form>
      </ModalBody>

      <ModalFooter
        style={{
          backgroundColor: 'rgb(39, 41, 61)',
          display: 'flex',
          justifyContent: 'end',
          paddingTop: '12px',
          gap: '12px',
        }}
      >
        <Button color='info' onClick={handleSubmit}>
          Update Subject
        </Button>
        <Button color='secondary' onClick={toggleModal}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditSubjectModal;
